import { FirestoreCollections, NewSmartList, SmartList } from '@griply/types';

import { newSmartListConverter } from './converters/smart-list';
import { addDocumentWithOwnerRole } from './helpers';

export const createSmartList = async (
  smartList: NewSmartList,
): Promise<SmartList> => {
  return addDocumentWithOwnerRole(
    FirestoreCollections.SmartLists,
    newSmartListConverter(smartList),
  );
};
